var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 57,
    viewBox: "0 0 172 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7036 16.0002C70.7041 16.0002 69.5741 16.2652 68.3131 16.793C65.4375 18.253 64 20.2483 64 22.78V34.1731C64 35.6176 64.5375 36.9768 65.6142 38.2504C67.3826 40.0833 69.4668 41 71.8657 41H97.8841C97.9609 41 97.9997 40.9624 97.9997 40.8833V32.3564V30.4916V27.7056C97.9997 26.6735 97.826 26.4143 97.0857 26.4143H83.9906C83.9139 26.4293 83.8751 26.467 83.8751 26.531V32.2388C83.8751 32.3164 83.9124 32.3563 83.9906 32.3563H90.0641V35.0813H75.9481C75.4404 35.0813 75.0023 35.0045 74.6335 34.8494C72.8189 34.1038 71.9114 32.8145 71.9114 30.9817V25.856C71.9114 25.6692 71.9487 25.3665 72.027 24.9477C72.7651 22.944 74.0722 21.9413 75.9482 21.9413H97.8845C97.9613 21.9413 98 21.9036 98 21.8245V16.1167C98 16.0565 97.9628 16.0151 97.8845 16L71.7036 16.0002Z",
    fill: "#F29C25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.143 16.0005H126.858C129.964 16.0005 132.363 17.212 134.054 19.6351C134.685 20.6292 135 21.7475 135 22.9901V34.29C135 36.5266 133.777 38.3905 131.332 39.8816C129.825 40.6272 128.572 41 127.573 41H101.116C101.039 41 101 40.9611 101 40.8832V35.175C101.015 35.1128 101.053 35.0816 101.116 35.0816H125.081C126.404 34.9416 127.065 34.2659 127.065 33.0546V31.214H109.143C105.821 31.214 103.33 29.8549 101.669 27.1368C101.223 26.1582 101 25.2651 101 24.4575V22.71C101 20.5821 102.146 18.757 104.437 17.2348C105.852 16.4116 107.42 16.0005 109.143 16.0005ZM108.912 23.9453C108.912 24.7841 109.412 25.3821 110.412 25.7393C110.55 25.7694 110.719 25.7845 110.919 25.7845H127.066V23.9439C127.066 22.81 126.481 22.1421 125.313 21.9402H110.919C109.935 21.9402 109.289 22.4372 108.982 23.4313C108.937 23.5713 108.915 23.7422 108.915 23.9441L108.912 23.9453Z",
    fill: "url(#paint0_linear_5_369)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.116 16.0002H171.884C171.961 16.0152 172 16.0541 172 16.1169V21.8251C172 21.9029 171.961 21.9418 171.884 21.9418H145.981V23.3863C145.981 24.7221 146.935 25.522 148.841 25.7861H163.857C166.964 25.7861 169.363 26.9976 171.054 29.4207C171.685 30.4613 172 31.5098 172 32.566V34.1736C172 36.4102 170.87 38.2585 168.609 39.7186C167.179 40.5728 165.557 41 163.742 41H138.116C138.039 41 138 40.9611 138 40.8832V35.1751C138.015 35.1128 138.053 35.0817 138.116 35.0817H161.966C162.935 35.0817 163.604 34.6468 163.973 33.777C164.034 33.4045 164.065 33.1871 164.065 33.1248C164.065 32.3482 163.665 31.7657 162.866 31.3775C162.62 31.2686 162.32 31.2141 161.966 31.2141H146.143C142.96 31.2141 140.538 29.9638 138.877 27.4631C138.293 26.4845 138 25.4594 138 24.3876V16.1168C138.015 16.0389 138.053 16.0002 138.116 16.0002Z",
    fill: "url(#paint1_linear_5_369)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.08878V40.7579L25.7867 56.2912L53.5978 40.7579V1.08878H34.4612C37.9796 4.68047 36.6954 10.0716 36.6954 10.0716C36.6954 10.0716 32.3377 31.591 27.5474 20.2279C24.2373 12.8169 9.57476 13.6182 7.65718 1.08878H0Z",
    fill: "url(#paint2_linear_5_369)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09668 6.33774V38.4636L25.9799 51.0422L48.5023 38.4636V6.33774H36.8413C37.0854 8.42022 36.6954 10.0716 36.6954 10.0716C36.6954 10.0716 32.3377 31.591 27.5475 20.2279C24.7884 14.0507 14.1429 13.5788 9.56382 6.33774H5.09668Z",
    fill: "url(#paint3_linear_5_369)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35645 10.7255V36.5455L26.1398 46.6544L44.2425 36.5455V10.7255H36.5533C35.7942 14.1494 31.8509 30.4366 27.5474 20.2279C25.484 15.6084 19.0098 14.1805 13.9605 10.7255H9.35645Z",
    fill: "url(#paint4_linear_5_369)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7654 1.08869C10.7654 1.08869 12.8234 8.47384 21.8059 12.8803C28.7408 16.2824 31.9234 33.1629 30.0504 42.0081C29.1009 46.3139 23.5445 49.9238 19.6101 52.5713L25.7868 56.2911L37.4312 49.7868C36.1861 47.9867 34.9848 46.2776 34.1541 44.8156C29.9171 37.3584 34.1532 24.308 36.6954 10.0716C37.0531 -2.65787 19.6422 1.08869 10.7654 1.08869Z",
    fill: "#F29C25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8755 3.3088C14.8755 3.3088 30.7144 11.0116 31.3128 22.6451C39.2569 6.60198 29.4338 0.520678 14.8755 3.3088Z",
    fill: "#FAD121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2858 5.96247C22.2858 5.96247 30.4103 10.1951 31.1655 16.6155C33.2649 8.61372 29.1331 5.61044 22.2858 5.96247Z",
    fill: "#FBDC5B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3953 43.7203C31.3953 43.7203 28.5831 49.2185 24.0976 51.9367C22.9278 52.6456 22.0133 53.1777 21.2927 53.5848L25.7867 56.2912L34.9602 51.1676C33.6877 49.0328 31.9993 45.9554 31.3953 43.7203Z",
    fill: "#FAD121"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0331 48.6096C31.0331 48.6096 29.7788 51.0631 27.7778 52.2757C26.7842 52.8779 25.034 53.9692 23.5256 54.9284L25.7867 56.2912L32.8668 52.3372C32.2961 51.4099 31.3435 49.7582 31.0331 48.6096Z",
    fill: "#FBDC5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1V40.6692L25.7867 56.2024L53.5977 40.6692V1H34.4612C37.9796 4.59171 36.6954 9.98287 36.6954 9.98287C36.6954 9.98287 32.3376 31.5022 27.5474 20.1391C24.2373 12.7282 9.57477 13.5295 7.6572 1H0Z",
    fill: "url(#paint5_linear_5_369)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09668 6.33777V38.4636L25.9799 51.0422L48.5023 38.4636V6.33777H36.8412C37.0854 8.42025 36.6954 10.0717 36.6954 10.0717C36.6954 10.0717 32.3377 31.591 27.5475 20.2279C24.7884 14.0508 14.1429 13.5788 9.56383 6.33777H5.09668Z",
    fill: "url(#paint6_linear_5_369)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35657 10.7255V36.5455L26.1399 46.6544L44.2426 36.5455V10.7255H36.5534C35.7943 14.1494 31.851 30.4366 27.5475 20.2279C25.4842 15.6084 19.0099 14.1805 13.9606 10.7255H9.35657Z",
    fill: "url(#paint7_linear_5_369)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7654 1.08879C10.7654 1.08879 12.8234 8.47392 21.8059 12.8804C28.7408 16.2825 31.9233 33.163 30.0504 42.0082C29.1009 46.3139 23.5445 49.9239 19.6101 52.5714L25.7867 56.2912L37.4312 49.7869C36.1861 47.9867 34.9848 46.2777 34.1541 44.8156C29.9171 37.3584 34.1532 24.3081 36.6954 10.0717C37.0531 -2.65779 19.6422 1.08879 10.7654 1.08879Z",
    fill: "#F29C25"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8755 3.30886C14.8755 3.30886 30.7144 11.0117 31.3128 22.6452C39.2569 6.60202 29.4338 0.520738 14.8755 3.30886Z",
    fill: "#FAD121"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2858 5.9625C22.2858 5.9625 30.4103 10.1951 31.1655 16.6155C33.2649 8.61375 29.1331 5.61047 22.2858 5.9625Z",
    fill: "#FBDC5B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3953 43.7203C31.3953 43.7203 28.5831 49.2185 24.0976 51.9366C22.9277 52.6456 22.0133 53.1777 21.2927 53.5848L25.7867 56.2912L34.9602 51.1676C33.6877 49.0328 31.9993 45.9554 31.3953 43.7203Z",
    fill: "#FAD121"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0331 48.6096C31.0331 48.6096 29.7788 51.0631 27.7778 52.2757C26.7841 52.8779 25.034 53.9692 23.5256 54.9284L25.7867 56.2911L32.8668 52.3371C32.2961 51.4098 31.3435 49.7582 31.0331 48.6096Z",
    fill: "#FBDC5B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_369",
    x1: 64.6938,
    y1: 28.5003,
    x2: 171.306,
    y2: 28.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534848,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_369",
    x1: 65.388,
    y1: 28.4999,
    x2: 172,
    y2: 28.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534848,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_369",
    x1: 0.000587398,
    y1: 1.089,
    x2: 53.5983,
    y2: 40.7583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534848,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_369",
    x1: 5.09685,
    y1: 28.6898,
    x2: 53.5982,
    y2: 1.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534848,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_369",
    x1: 9.35643,
    y1: 28.6898,
    x2: 48.3383,
    y2: 6.5063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534848,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_369",
    x1: 0.000586351,
    y1: 1.00023,
    x2: 53.5983,
    y2: 40.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534848,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_369",
    x1: 5.09685,
    y1: 28.6899,
    x2: 53.5982,
    y2: 1.08903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534848,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_369",
    x1: 9.35655,
    y1: 28.6899,
    x2: 48.3384,
    y2: 6.50633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534848,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.45ca22d4820bc8d5794ea057ea1136e6.svg";
export { ForwardRef as ReactComponent };